module.exports = __webpack_public_path__ + "img/20260309_2.baae6817.png";